module.exports = __webpack_public_path__ + "static/media/professional-panel.40745c41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/bridging-the-gap/professional-panel.jpg
// module id = 364
// module chunks = 0